import { axiosInstance } from "../../../api/axiosInstance.tsx";

export const fetchVendors = async (): Promise<any[]> => {
  try {
    const response = await axiosInstance.get("/vendors/view_vendors");
    return response.data.map((vendor) => ({
      id: vendor.id,
      boldText: vendor.vendorName,
      textColumn1: vendor.vendorAddress,
      textColumn2: vendor.vendorType,
      textColumn3: vendor.vendorContactNumber,
      textColumn4: vendor.vendorEmail,
      status: vendor.vendorStatus,
    }));
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "Gagal mengambil data vendor. Silakan coba lagi."
    );
  }
};

export interface vendorSearchParams {
  vendorName?: string;
  vendorAddress?: string;
  vendorContactNumber?: string;
  vendorEmail?: string;
  vendorType?: string;
  vendorTaxId?: string;
  vendorBankDetails?: string;
  vendorStatus?: string;
  limit?: number;
  offset?: number;
  keyword?: string;
  orderBy?: string;
  order?: string;
}

export const getVendors = async (params: vendorSearchParams = {}) => {
  const response = await axiosInstance.get("/vendors/search_vendors", {
    params,
  });
  return response.data;
};

// Step 1: Create Vendor
export const createVendor = async (data) => {
  const payload = {
    vendorName: data.vendorName,
    vendorAddress: data.vendorAddress,
    vendorCountry: data.vendorCountry,
    vendorProvince: data.vendorProvince,
    vendorCity: data.vendorCity,
    vendorDistrict: data.vendorDistrict,
    vendorContactNumber: data.vendorContactNumber,
    vendorEmail: data.vendorEmail,
    vendorType: data.vendorType,
    vendorTaxId: data.vendorTaxId,
    vendorBankDetails: data.vendorBankName,
    vendorBankName: data.vendorBankName,
    vendorBankAccountNo: data.vendorBankAccountNo,
    vendorBankAccountName: data.vendorBankAccountName,
    vendorStatus: data.vendorStatus,
  };

  const response = await axiosInstance.post(`vendors/create_vendor`, payload);
  return response.data; // contains the item `id` or `code`
};

// Create Office Location
export const createVendorLocation = async (data) => {
  const response = await axiosInstance.post(
    `/vendorLocations/create_vendor_location`,
    data
  );
  return response.data; // contains the office `id` or `code`
};

// Step 2: Upload Photo by Item ID
export const uploadItemPhoto = async (id, file) => {
  const formData = new FormData();
  formData.append("photo", file);

  return axiosInstance.post(`/vendors/upload_photo/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const fetchVendorPhotoBlob = async (
  filename: string
): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(`/vendors/photo/${filename}`, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(response.data);
    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};

// Delete vendor
export const deleteVendor = async (id: string) => {
  try {
    await axiosInstance.delete(`/vendors/delete_vendor/${id}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor"
    );
  }
};

export const deleteVendorLocation = async (id: number) => {
  try {
    await axiosInstance.delete(`/vendorLocations/delete_vendor_location/${id}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor location"
    );
  }
};

// Update Vendor
export const updateVendor = async (data) => {
  const payloadEdit = {
    vendorId: data.vendorId,
    vendorName: data.vendorName, // Perbaiki field name
    vendorAddress: data.vendorAddress,
    vendorCountry: data.vendorCountry,
    vendorProvince: data.vendorProvince,
    vendorCity: data.vendorCity,
    vendorDistrict: data.vendorDistrict,
    vendorContactNumber: data.vendorContactNumber,
    vendorEmail: data.vendorEmail,
    vendorType: data.vendorType,
    vendorTaxId: data.vendorTaxId,
    vendorBankDetails: data.vendorBankName,
    vendorBankName: data.vendorBankName,
    vendorBankAccountNo: data.vendorBankAccountNo,
    vendorBankAccountName: data.vendorBankAccountName,
    vendorStatus: data.vendorStatus,
  };

  const response = await axiosInstance.put(
    `/vendors/update_vendor/${data.vendorId}`,
    payloadEdit
  );
  return response.data;
};

// Fetch Vendor Details by ID
export const getVendorById = async (id) => {
  try {
    const response = await axiosInstance.get(`/vendors/view_vendor/${id}`);
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Terjadi kesalahan saat mengambil data vendor"
    );
  }
};

// Fungsi untuk mencari vendor berdasarkan keyword
export const sesarchVendors = async (searchQuery: string) => {
  try {
    const response = await axiosInstance.get(
      `/vendors/search_vendors?keyword=${searchQuery}`
    );
    return response.data; // Pastikan response sesuai format yang diterima tabel
  } catch (error) {
    console.error("Error fetching vendors:", error);
    throw (
      error.response?.data?.message ||
      "Terjadi kesalahan saat mengambil data karyawan"
    );
  }
};
